import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api/datapool-v2`;

const client = axios.create({ baseURL: API_BASE });
client.interceptors.request.use((c) => {
  const t = localStorage.getItem("sv_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});
client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("sv_token");
      localStorage.removeItem("sv_user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const createBatch = () => client.post("/batches", {});
export const uploadCsv = (batchId, files) => {
  const fd = new FormData();
  (files || []).forEach((f) => fd.append("files", f));
  return client.post(`/batches/${batchId}/upload-csv`, fd);
};
export const getRecords = (batchId) => client.get(`/batches/${batchId}/records`);
export const diagnose = (batchId) => client.post(`/batches/${batchId}/diagnose`, {});
export const approveRecord = (recordId) => client.post(`/records/${recordId}/approve`, {});
export const manualAllocate = (recordId, payload) => client.post(`/records/${recordId}/manual-allocate`, payload);
export const commit = (batchId) => client.post(`/batches/${batchId}/commit`, {});
export const apply = (batchId) => client.post(`/batches/${batchId}/apply`, {});
export const status = (batchId) => client.get(`/batches/${batchId}/status`);
